<template>
  <div style="margin-top:10px">
    <div>
      <div class="view-container">
        <div class="view-box">
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">协议编号</div>
              <div class="view-value">{{ptc.ptccode}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">协议名称</div>
              <div class="view-content">{{ptc.ptcname}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">预算金额</div>
              <div class="view-con" v-if="ptc.ptcbudgetamt">￥{{ptc.ptcbudgetamt | qfwVal}}元
                （<amount :money="String(ptc.ptcbudgetamt)"/>）</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">采购人</div>
              <div class="view-value">{{ptc.ptcpcomname}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">联系人</div>
              <div class="view-value">{{ptc.pusername}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">手机</div>
              <div class="view-value">{{ptc.usermobile?ptc.usermobile:'暂无'}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">电话</div>
              <div class="view-value">{{ptc.usertel?ptc.usertel:'暂无'}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">邮箱</div>
              <div class="view-value">{{ptc.useremail?ptc.useremail:'暂无'}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">交易方式</div>
              <div class="view-value">{{ptc.ptctrademodeflg?ptc.ptctrademodeflg:'暂无'}}</div>
            </div>
          </div>
          <div class="view-row" v-if="ptc.dptObj">
            <div class="view-field">
              <div class="view-label">业务员</div>
              <div class="view-value"> {{ptc.dptObj.dptname}}  /  {{ptc.dptObj.username}}  /  {{ptc.dptObj.usercode}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">分派部门</div>
              <div class="view-value">{{ptc.dptname?ptc.dptname:'暂无'}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">协议文本</div>
              <div class="view-text" v-html="ptc.ptctext" style="margin-top:-12px"></div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">协议文件</div>
                <div v-if="ptc.appends && ptc.appends.appendid" class="view-filelist">
                  <div class="view-fileitem">
                    <div class="view-filename" @click="downFile(ptc.appends.appendurl)">
                      <a :src="uploadAddr + ptc.appends.appendurl">{{ptc.appends.appendfilename}}</a>
                    </div>
                  </div>
                </div>
                <div v-else class="view-value">无</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import request from '@/utils/request'
  import _ from 'lodash'
  import common from '@/mixin/common'
  import amount from '../common/amount'
  import utils from '../../assets/js/utils'

  export default {
    name: "ptcViewFile",
    mixins: [common],
    data () {
      return {
            ptc:{},
            btnLoading:false
      }
    },
    async created () {
      
    },
    filters:{
      qfwVal (value) {
        if (!!value && +value > 0) {
          return utils.comdify(value)
        } else {
          return value
        }
      },
    },
    mounted () {
      this.getptcInfo()
    },
    components: {amount},
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      }
    },
    methods: {
        async getptcInfo(){
          let data = await request({
            url: '/xmgl/ptc/getptcInfo',
            method: "get",
            params: {ptcid:this.$route.query.ptcid}
          })
          this.ptc = data
        },
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/filelist";
</style>
